var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-btn', {
    attrs: {
      "fab": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.play
    }
  }, [_vm.name != _vm.voice.name || _vm.cue != _vm.voice.cue ? _c('v-icon', [_vm._v("mdi-play")]) : _vm.voice.loading ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm.voice.playing ? _c('v-icon', [_vm._v("mdi-volume-high")]) : _c('v-icon', [_vm._v("mdi-play")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }